import { CUSTOMER_JOURNEY_HOTEL } from './../const';

function action(token, lang, context) {
  return { type: CUSTOMER_JOURNEY_HOTEL, token, lang, context };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyHotel.js